export default {
  palette: {
    primary: {
      light: '#33EBD0',
      main: '#00E5C3',
      dark: '#00B89C',
      contrastText: '#fff'
    },
    secondary: {
      light: '#33EBD0',
      main: '#00E5C3',
      dark: '#00B89C',
      contrastText: '#fff'
    }
  },
  status: {
    danger: 'orange',
  },
  typography: {
    button: {
      fontWeight: 400,
      textAlign: 'capitalize'
    },
  },
};
